// @ts-nocheck
import * as Types from '../../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type SaveProductAttributesMutationVariables = Types.Exact<{
  input: Types.SaveProductAttributesInput;
}>;


export type SaveProductAttributesMutation = { __typename?: 'Mutation', saveProductAttributes: { __typename?: 'SaveProductAttributesResult', attributes: Array<{ __typename?: 'ProductAttribute', id: string, type: Types.ProductAttributeType, value: string }> } };


export const SaveProductAttributesDocument = gql`
    mutation SaveProductAttributes($input: SaveProductAttributesInput!) {
  saveProductAttributes(input: $input) {
    attributes {
      id
      type
      value
    }
  }
}
    `;
export type SaveProductAttributesMutationFn = Apollo.MutationFunction<SaveProductAttributesMutation, SaveProductAttributesMutationVariables>;

/**
 * __useSaveProductAttributesMutation__
 *
 * To run a mutation, you first call `useSaveProductAttributesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveProductAttributesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveProductAttributesMutation, { data, loading, error }] = useSaveProductAttributesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveProductAttributesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveProductAttributesMutation, SaveProductAttributesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SaveProductAttributesMutation, SaveProductAttributesMutationVariables>(SaveProductAttributesDocument, options);
      }
export type SaveProductAttributesMutationHookResult = ReturnType<typeof useSaveProductAttributesMutation>;
export type SaveProductAttributesMutationResult = Apollo.MutationResult<SaveProductAttributesMutation>;
export type SaveProductAttributesMutationOptions = Apollo.BaseMutationOptions<SaveProductAttributesMutation, SaveProductAttributesMutationVariables>;